import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { CmsLink } from '@/models';

@Component({
  name: 'CmgFooterLink',
})
export default class CmgFooterLink extends Vue {
  @Prop({ required: true, type: Object })
  link!: CmsLink;
}
